import { useSelector } from 'react-redux'

import settings from '@/utils/settings'
import { translate } from '@/utils/translations'

const TaxExemptionLink = () => {
  const isBulkEnabled = useSelector(state => state.currentRegion.bulkEnabled)

  return (
    <If condition={isBulkEnabled}>
      <li className='u-flush--bottom'>
        <a
          className='exemption-info underline'
          href={settings.tax_exemption_url}
          rel="noopener noreferrer"
          target='_blank'
        >
          {translate('common.exemption_info')}
        </a>
      </li>
    </If>
  )
}

export default TaxExemptionLink
